import getBG from '../../utils/utils';

export default {
    name: 'added-service',
    data() {
        return {
            backgroundImage: '',
            content: ''
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            this.backgroundImage = await getBG.call(this, 'AddService');
            this.$http
                .fetchData('contentManage/getContentManageList', {
                    contentType: 'homePageAddedService'
                })
                .then(res => {
                    this.content = res[0].content;
                })
                .catch(err => {
                    this.$message({
                        message: err,
                        type: 'error'
                    });
                });
        }
    }
};
